// KÜLSŐ SZOLGÁLTATÁS-JELEK (Google Drive · Google Meet · Zoom · Microsoft OneDrive · Dropbox) —
// EGYSZERŰSÍTETT, EGYSZÍNŰ (currentColor) glyphek.
//
// MIÉRT VAN SAJÁT SVG (a „csak Heroicons" szabály mellett): ezek MÁRKA-jelek, amik a Heroicons-ban nem
// szerepelnek, és a felhasználó pont a FELISMERHETŐSÉGET kérte (az üzenet-írás három link-mezőjének elején).
// Ugyanaz a kivétel, ami az `AtlasMark`-nál: a `components/brand/` a márka-glyphek helye — máshol továbbra sem
// rajzolunk SVG-t kézzel. A jelek SZÁNDÉKOSAN egyszínűek és leegyszerűsítettek (nem a márka színes logója):
// a mező-előtag ikon-szerepben áll, örökli a szöveg-színt, és nem viszi be a logók színkészletét a felületre.
//
// MINDEGYIK: 24×24 viewBox, `currentColor`, `aria-hidden` (a mező akadálymentes nevét az `aria-label` adja).
import { type SVGProps } from 'react';

type MarkProps = SVGProps<SVGSVGElement>;

/** Google Drive — a jellegzetes háromszög-sziluett (a három lap egyszínű körvonalként). */
export function GoogleDriveMark(props: MarkProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      {/* Egyszerűsített sziluett: háromszög + a jellegzetes vízszintes „szalag" (16px-en a három-lapos
          eredeti belső vonalai összemosódtak — mérve a beúszó panelen). */}
      <path
        d="M12 3.5 21 19h-18L12 3.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M7.4 14.2h9.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

/** Google Meet — kamera-test + a jobb oldali „play" ék (a Meet ikon jellegzetes formája). */
export function GoogleMeetMark(props: MarkProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <rect
        x="2.5"
        y="6"
        width="12"
        height="12"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 10.2 21 6.6v10.8l-6.5-3.6v-3.6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Zoom — lekerekített négyzet a videó-kamera glyph-fel (a Zoom app-ikon sziluettje). */
export function ZoomMark(props: MarkProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <rect x="2.5" y="2.5" width="19" height="19" rx="5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M7 9.2h5.4v5.6H7V9.2Zm5.4 1.9L17 9v6l-4.6-2.1v-1.8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Microsoft OneDrive — a jellegzetes felhő-sziluett (egyszínű körvonal). */
export function OneDriveMark(props: MarkProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M7.6 18.5h10.9a2.9 2.9 0 0 0 .3-5.8 4.4 4.4 0 0 0-8.2-2.2 3.6 3.6 0 0 0-3 3.6 3.6 3.6 0 0 0 0 .1 2.2 2.2 0 0 0 0 4.3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Dropbox — a két egymásba tükrözött rombusz (a doboz-logó sziluettje). */
export function DropboxMark(props: MarkProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M7 4 2.5 7.2 7 10.4l4.5-3.2L7 4Zm10 0-4.5 3.2 4.5 3.2 4.5-3.2L17 4ZM2.5 13.6 7 10.4l4.5 3.2L7 16.8l-4.5-3.2Zm10 0 4.5-3.2 4.5 3.2-4.5 3.2-4.5-3.2ZM7 18.2l4.5-3 4.5 3-4.5 2.6L7 18.2Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </svg>
  );
}
